<template>
  <FormItemWrapper class="summer">
    <FormItemLabel slot="label">
      {{ $t('formItemLabelHighTariff') }}
    </FormItemLabel>
    <Tooltip
      v-if="$t('formItemTooltipHighTariff')"
      slot="tooltip"
      :content="$t('formItemTooltipHighTariff')"
    />
    <el-input
      v-model="activeHT"
      type="number"
      class="summer"
      placeholder=""
    >
      <template slot="append">kWh</template>
    </el-input>
  </FormItemWrapper>
</template>

<script>
import Vue from 'vue';
import { onKeydownAllowNumbersOnly } from '@/utils/validation';
import debounce from 'lodash/debounce';
import { Input } from 'element-ui';
import FormItemWrapper from '@/components/formItem/Wrapper.vue';
import FormItemLabel from '@/components/formItem/Label.vue';
import Tooltip from '@/components/Tooltip.vue';

Vue.use(Input);

export default {
  name: 'CalculationActiveHT',
  components: {
    FormItemWrapper,
    FormItemLabel,
    Tooltip,
  },
  computed: {
    activeHT: {
      get() {
        return this.$store.state.calculation.activeCalculationData.activeHT;
      },
      set(value) {
        this.update(value);
      },
    },
  },
  methods: {
    update: debounce(function update(value) {
      this.$store.commit('calculation/SET_ACTIVE_HT', Number(value));
    }, 500),
    onKeydownAllowNumbersOnly,
  },
};
</script>
